module.exports = __webpack_public_path__ + "img/@awards_img_01.a88757e1.jpg";